'use strict';

DoohApps.factory('ConfiguratorBlock', ['restApi', function (restApi) {
    var controllerName = 'AppStore/';

    return {
        getConfiguratorBlocksbyAppVersion: function (successCallback, id) {
            restApi.GetApiMethod(successCallback, controllerName + 'GetAppConfigurationBlocks?AppVersionID=' + id);
        },
    }
}]);
